import { Routes } from '@angular/router';
import { ReportsPageComponent } from './pages/reports-page.component';

export const reportsRoutes: Routes = [
  {
    path: 'reports',
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'summary',
      },
      {
        path: 'summary',
        loadComponent: () =>
          import('./pages/reports-page.component').then(() => ReportsPageComponent),
      },
      {
        path: 'detailed',
        loadComponent: () =>
          import('./pages/reports-page.component').then(() => ReportsPageComponent),
      },
    ],
  },
];
